import { render, staticRenderFns } from "./DashboardIcon.vue?vue&type=template&id=baf79230&scoped=true&"
var script = {}
import style0 from "./DashboardIcon.vue?vue&type=style&index=0&id=baf79230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf79230",
  null
  
)

export default component.exports